import { DataLoggerDetails } from '../hooks/useDataLoggerDetails';
import { SensorConfig } from '../hooks/useCreateOrUpdateDataLogger';

export const validateFirstTab = (
  formData: Partial<DataLoggerDetails>,
  setErrors: (errors: { [key: string]: string }) => void
): boolean => {
  const newErrors: { [key: string]: string } = {};
  const forbiddenPorts = [21, 22, 23, 25, 53, 80, 110, 143, 443, 3306, 5432, 8080];
  const isValidIPv4 = (ip: string) => {
    return /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip);
  };
  if (!formData.name) newErrors.name = 'Name is required';
  if (!formData.serialNumber) newErrors.serialNumber = 'Serial Number is required';
  if (!formData.plcBrand) newErrors.plcBrand = 'PLC Brand is required';
  if (!formData.pollingInterval) newErrors.pollingInterval = 'Polling Interval is required';
  if (!formData.plcModel) newErrors.plcModel = 'PLC Model is required';
  if (!formData.asset || !formData.asset._id) newErrors.asset = 'Asset is required';
  if (!formData.modbusHost) {
    newErrors.modbusHost = 'Modbus Host is required';
  } else if (!isValidIPv4(formData.modbusHost)) {
    newErrors.modbusHost = 'Enter a valid IPv4 address';
  }
  if (!formData.modbusPort) newErrors.modbusPort = 'Modbus Port is required';
  if (formData.modbusPort && forbiddenPorts.includes(Number(formData.modbusPort))) {
    newErrors.modbusPort = 'This port is not allowed for Modbus';
  }
  if (!formData.unitIdReal) newErrors.unitIdReal = 'Unit ID Real is required';
  if (!formData.startAddressReal) newErrors.startAddressReal = 'Start Address Real is required';
  if (!formData.registerCountReal) newErrors.registerCountReal = 'Register Count Real is required';
  if (!formData.unitIdBool) newErrors.unitIdBool = 'Unit ID Bool is required';
  if (!formData.startAddressBool) newErrors.startAddressBool = 'Start Address Bool is required';
  if (!formData.registerCountBool) newErrors.registerCountBool = 'Register Count Bool is required';
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

export const validateSensorConfig = (config: SensorConfig) => {
  const sensorErrors: { [key: string]: string } = {};
  if (!config.sensor.sensorTag) sensorErrors.sensorTag = 'Sensor Tag is required';
  if (!config.sensorType) sensorErrors.sensorType = 'Sensor Type is required';
  
  if (config.sensorType === 'analog') {
    if (!config.start && config.start !== 0) sensorErrors.start = 'Start Register Address is required';
    if (!config.end && config.end !== 0) sensorErrors.end = 'End Register Address is required';
    if (!config.type) sensorErrors.type = 'Type is required';
    if (!config.wordOrder) sensorErrors.wordOrder = 'Word Order is required';
    if (!config.scalingFactor && config.scalingFactor !== 0) sensorErrors.scalingFactor = 'Scale is required';
  }
  
  if (config.sensorType === 'boolean') {
    if (!config.bitIndex && config.bitIndex !== 0) sensorErrors.bitIndex = 'Bit Index is required';
  }
  
  return sensorErrors;
};

export function validateSensorConfigFrontend(config: any) {
  const errors: { [key: string]: string } = {};
  if (!config.sensor || typeof config.sensor !== 'object' || !config.sensor._id ) {
    errors['sensor'] = 'Sensor is required';
  }
  if (!config.sensor?.sensorTag) {
    errors['sensorTag'] = 'Sensor tag is required';
  }
  if (!config.sensorType) {
    errors['sensorType'] = 'Sensor type is required';
  }
  if (config.sensorType === 'analog') {
    const isTotalizerReference = !!config.referenceSensor && config.referenceSensorPurpose === 'totalizer';
    if (!isTotalizerReference) {
      if (!config.type) errors['type'] = 'Type is required';
      if (config.start === undefined || config.start === null || config.start === '') errors['start'] = 'Start Register Address is required';
      if (config.end === undefined || config.end === null || config.end === '') errors['end'] = 'End Register Address is required';
      if (!config.wordOrder) errors['wordOrder'] = 'Word Order is required';
      if (config.scalingFactor === undefined || config.scalingFactor === null || config.scalingFactor === '') errors['scalingFactor'] = 'Scaling Factor is required';
    }
  }
  if (config.sensorType === 'boolean') {
    if (config.bitIndex === undefined || config.bitIndex === null || config.bitIndex === '') errors['bitIndex'] = 'Bit Index is required';
  }
  if (config.referenceSensor && !config.referenceSensorPurpose) {
    errors.referenceSensorPurpose = 'Purpose is required when a reference sensor is selected';
  }
  return errors;
}

export function getSensorReferenceResetFields(referenceSensor: any) {
  return {
    referenceSensor,
    start: '',
    end: '',
    type: '',
    wordOrder: '',
    scalingFactor: '',
    function: '',
    modbusMisfireTotalizer: false,
  };
} 